import { useRouter } from "next/dist/client/router";
import { memo, useCallback, useMemo } from "react";
import { useRecoilState } from "recoil";
import { TicketStatusJp } from "../../../entities/Ticket";
import { useShopAgents } from "../../../hooks/agentHooks";
import { toDate, ymdhmDisplayJp } from "../../../lib/datetime";
import tabListState from "../../../state/tabListState";
import ticketSelectState, { TICKET_SELECT_KEYS } from "../../../state/ticketSelectState";
import useAuthContext from "../../context/AuthContext";

const DefaultTicketListRow = memo(({ ticket }:{ ticket }) => {

  const router = useRouter();
  const [tabList, setTabList] = useRecoilState(tabListState);
  const {currentShop} = useAuthContext()
  const [agents, setAgents] = useShopAgents(currentShop?.id)
  const [selectState, setSelectState] = useRecoilState(ticketSelectState)
  const isSelected = selectState[TICKET_SELECT_KEYS.assign]?.includes(ticket?.id)

  const onClick = useCallback(() => {
    const tab = tabList.pages.find((_tab) => _tab.id == ticket.id);
    const pages = [...tabList.pages, {
      id: ticket.id,
      name: ticket.title,
      type: 'ticket',
      route: ticket.ticketRoute
    }]
    const currentIndex = pages.findIndex((page) => page.id == ticket.id)

    if (!tab) {
      setTabList({
        ...tabList,
        pages: pages,
        current: currentIndex
      })
    } else {
      setTabList({
        ...tabList,
        current: currentIndex
      })
    }
    router.push(`/tickets/${ticket?.id}`)
  },[router, ticket.id])

  const onClickSelect = (e) => {
    e.stopPropagation();
    e.preventDefault();

    setSelectState({
      ...selectState,
      [TICKET_SELECT_KEYS.assign]: isSelected ?
        selectState[TICKET_SELECT_KEYS.assign]?.filter((v) => v != ticket.id) :
        Array.from(new Set([...selectState[TICKET_SELECT_KEYS.assign], ticket.id]))
    })
  }

  const startedAt = useMemo(() => ymdhmDisplayJp(toDate(ticket?.startedAt)), [ticket?.startedAt])
  const lastUpdatedAt = useMemo(() => ymdhmDisplayJp(toDate(ticket?.lastUpdatedAt)), [ticket?.lastUpdatedAt])
  const lastReceivedAt = useMemo(() => ymdhmDisplayJp(toDate(ticket?.lastReceivedAt)), [ticket?.lastReceivedAt])
  const lastSentAt = useMemo(() => ymdhmDisplayJp(toDate(ticket?.lastSentAt)), [ticket?.lastSentAt])
  const agent = agents?.find((agent) => agent.id == ticket?.agent)

  return (<tr key={ticket.id}
    className="cursor-pointer border-b box-border border-separate first:border-t border-gray-300"
    onClick={onClick}>
    <td
      className="p-4 text-center text-xl break-words whitespace-pre-wrap"
      onClick={onClickSelect}
    >
      {isSelected}
      <label htmlFor="selectTicket" className={`check-label ${isSelected && "before:border-gray-500 after:opacity-100"}`}></label>
      <input id="selectTicket" className={`hidden`} type="checkbox" />
    </td>
    <td className="p-4 text-center text-xl break-words whitespace-pre-wrap">{ticket.id}</td>
    <td className="p-4 text-center text-xl break-words whitespace-pre-wrap">{TicketStatusJp[ticket.ticketStatus]}</td>
    <td className="p-4 text-center text-xl break-words whitespace-pre-wrap">{ticket.title}</td>
    <td className="p-4 text-center text-xl break-words whitespace-pre-wrap">{ticket.emailFrom}</td>
    <td className="p-4 text-center text-xl break-words whitespace-pre-wrap">{agent?.name || agent?.email}</td>
    <td className="p-4 text-center text-xl break-words whitespace-pre-wrap">{startedAt}</td>
    <td className="p-4 text-center text-xl break-words whitespace-pre-wrap">{lastUpdatedAt}</td>
    <td className="p-4 text-center text-xl break-words whitespace-pre-wrap">{lastReceivedAt}</td>
    <td className="p-4 text-center text-xl break-words whitespace-pre-wrap">{lastSentAt}</td>
  </tr>)
})

export default DefaultTicketListRow;